module.exports = __webpack_public_path__ + "media/share/map-expand@2x-7eba1c4c.png";